angular
  .module('app')
  .controller('SitemapController', function MyController($scope, ngStudentMenuQuery) {
    const menuItems = ngStudentMenuQuery.result.menuItems || [];
    const internalMenuItems = menuItems.filter((_) => _.uri.indexOf('#/') >= 0);
    const externalMenuItems = menuItems.filter((_) => _.uri.indexOf('http') >= 0);

    $scope.sitemap = [{
      title: 'Explore',
      links: internalMenuItems.map((_) => {
        return {
          title: _.title,
          uri: _.uri
        }
      })
    }, {
      title: 'Planner',
      uri: '#/my/ap3/student'
    }, {
      title: 'External Services',
      links: externalMenuItems.map((_) => {
        return {
          title: _.title,
          uri: _.uri
        }
      })
    }];

  });
